import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3916ad2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "detail"
};
const _hoisted_5 = {
  class: "sub_info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("view", {
  class: "sub_title"
}, "产品描述", -1));
const _hoisted_7 = {
  class: "title_detail_inner"
};
const _hoisted_8 = {
  key: 0,
  class: ""
};
const _hoisted_9 = {
  key: 1,
  class: "placeholder"
};
const _hoisted_10 = {
  key: 2,
  class: "expand"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "title_count"
};
const _hoisted_13 = {
  class: "sub_info"
};
const _hoisted_14 = {
  class: "sub_title"
};
const _hoisted_15 = /*#__PURE__*/_createTextVNode("产品图片 ");
const _hoisted_16 = {
  class: "image_count_des"
};
const _hoisted_17 = {
  class: "image_scroll"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 0,
  class: "photo-item upload",
  bindtap: "uploadImg"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "image_count"
};
const _hoisted_23 = {
  class: "sub_info"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("view", {
  class: "sub_title"
}, "预计筹资目标", -1));
const _hoisted_25 = {
  class: "money_info"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  class: "currency"
}, "¥", -1));
const _hoisted_27 = {
  class: "money_container"
};
const _hoisted_28 = {
  class: "confirmInfo"
};
const _hoisted_29 = {
  class: "nav_back"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "input_content"
};
const _hoisted_32 = {
  class: "title_info"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("view", {
  class: "title"
}, "产品描述", -1));
const _hoisted_34 = {
  class: "input_count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_Uploader = _resolveComponent("Uploader");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("view", _hoisted_2, [_createElementVNode("img", {
    class: "img",
    src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/project_intention_top.png', 750),
    mode: "aspectFit",
    "lazy-load": "true"
  }, null, 8, _hoisted_3)]), _createElementVNode("view", _hoisted_4, [_createElementVNode("view", _hoisted_5, [_hoisted_6, _createElementVNode("view", {
    class: "title_detail",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showTitleInput && $options.showTitleInput(...args))
  }, [_createElementVNode("view", _hoisted_7, [$data.title && $data.title.length ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString($data.title), 1)) : (_openBlock(), _createElementBlock("text", _hoisted_9, "简单描述设计亮点、产品介绍、产品定价")), $data.title && $data.title.length ? (_openBlock(), _createElementBlock("view", _hoisted_10, [_createElementVNode("img", {
    class: "expand_icon",
    src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/expand_inner.png', 64),
    mode: "aspectFit"
  }, null, 8, _hoisted_11)])) : _createCommentVNode("", true), _createElementVNode("view", _hoisted_12, _toDisplayString($data.title.length) + " / 500", 1)])])]), _createElementVNode("view", _hoisted_13, [_createElementVNode("view", _hoisted_14, [_hoisted_15, _createElementVNode("text", _hoisted_16, "不超过" + _toDisplayString($data.max_count) + "张", 1)]), _createElementVNode("view", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.image_list, (item, index) => {
    return _openBlock(), _createElementBlock("view", {
      key: index,
      class: "photo-item",
      onClick: _withModifiers($event => $options.showPic(index), ["stop"])
    }, [_createVNode(_component_van_image, {
      style: {
        "width": "100%",
        "height": "100%"
      },
      src: _ctx.$imgUrlFilter(item, 216),
      fit: "cover"
    }, null, 8, ["src"]), _createElementVNode("view", {
      class: "del",
      onClick: _withModifiers($event => $options.delImg(index), ["stop"])
    }, "x", 8, _hoisted_19)], 8, _hoisted_18);
  }), 128)), $data.image_list.length < $data.max_count ? (_openBlock(), _createBlock(_component_Uploader, {
    key: 0,
    deletable: "",
    multiple: "",
    accept: "image/*",
    "max-count": $data.max_count - $data.image_list.length,
    "after-read": $options.afterRead
  }, {
    default: _withCtx(() => [$data.image_list.length < $data.max_count ? (_openBlock(), _createElementBlock("view", _hoisted_20, [_createElementVNode("img", {
      class: "upload-icon",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/project_%20intention_image_add.png', 40)
    }, null, 8, _hoisted_21)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["max-count", "after-read"])) : _createCommentVNode("", true)]), _createElementVNode("view", _hoisted_22, _toDisplayString($data.image_list.length) + " / " + _toDisplayString($data.max_count), 1)]), _createElementVNode("view", _hoisted_23, [_hoisted_24, _createElementVNode("view", _hoisted_25, [_hoisted_26, _createElementVNode("view", _hoisted_27, [_createVNode(_component_van_field, {
    class: "money_input",
    type: "digit",
    maxlength: "13",
    modelValue: $data.money,
    "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => $data.money = $event), $options.moneyInputAction],
    formatter: $data.formatter,
    placeholder: "请输入金额"
  }, null, 8, ["modelValue", "formatter", "onUpdate:modelValue"])])])])]), _createElementVNode("view", _hoisted_28, [_createElementVNode("view", {
    class: _normalizeClass(['btn', {
      active: $data.isComplete
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.sendApply && $options.sendApply(...args))
  }, "确认并提交", 2)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
    class: "nav_icon",
    src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_white.png', 62),
    mode: "aspectFit",
    "lazy-load": "true",
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.goBack && $options.goBack(...args), ["self"]))
  }, null, 8, _hoisted_30)]), _createVNode(_component_van_overlay, {
    show: $data.titleInputShow,
    onClick: _cache[6] || (_cache[6] = _withModifiers($event => $data.titleInputShow = false, ["self"]))
  }, {
    default: _withCtx(() => [_createElementVNode("view", _hoisted_31, [_createElementVNode("view", _hoisted_32, [_hoisted_33, _createElementVNode("view", {
      style: {
        "position": "absolute",
        "right": "0px",
        "top": "50%",
        "transform": "translateY(-50%)",
        "color": "#00c4a1"
      },
      onClick: _cache[4] || (_cache[4] = _withModifiers($event => $data.titleInputShow = false, ["self"]))
    }, "完成")]), _createVNode(_component_van_field, {
      class: "title_input",
      type: "textarea",
      modelValue: $data.title,
      "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => $data.title = $event), $options.titleInputAction],
      maxlength: "500",
      placeholder: "简单描述设计亮点、产品介绍、产品定价",
      autosize: $data.autosizeData,
      autofocus: ""
    }, null, 8, ["modelValue", "autosize", "onUpdate:modelValue"]), _createElementVNode("view", _hoisted_34, _toDisplayString($data.title.length) + " / 500", 1)])]),
    _: 1
  }, 8, ["show"])], 64);
}